import { render, staticRenderFns } from "./BigExcellence.vue?vue&type=template&id=f04b2eea&scoped=true&"
import script from "./BigExcellence.vue?vue&type=script&lang=js&"
export * from "./BigExcellence.vue?vue&type=script&lang=js&"
import style0 from "./BigExcellence.vue?vue&type=style&index=0&id=f04b2eea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f04b2eea",
  null
  
)

export default component.exports